import { useCallback, useContext, useState } from "react";
import { api } from "../../../api";
import { OverflowFrame } from "../../../externalComponents";
import { PageHeading } from "../../../externalComponents/PageHeading";
import { SettingsSidebar } from "../../../externalComponents/SettingsSidebar";
import {
  Description,
  Field,
  Label,
} from "../../../externalComponents/tailwind/fieldset";
import SelectInput from "../../../externalComponents/tailwind/select-input";
import { CustomerContext } from "../../../providers";
import { Divider } from "../../../externalComponents/tailwind/divider";

const OPTIN_EXPIRATION_PERIOD_OPTIONS = [1, 2, 3, 4, 5].map((year) => ({
  label: `${year} year${year > 1 ? "s" : ""}`,
  value: year,
}));

export default function GdprPage() {
  const { customer } = useContext(CustomerContext);
  const [optinExpirationPeriodInYears, setOptinExpirationPeriodInYears] =
    useState(customer.optinExpirationPeriodInYears ?? 2);

  const handleOptinExpirationPeriodChange = useCallback(
    async (value) => {
      const intValue = parseInt(value, 10);
      setOptinExpirationPeriodInYears(intValue);
      await api.customer.update(customer.id, {
        optinExpirationPeriodInYears: intValue,
      });
    },
    [customer.id],
  );

  return (
    <>
      <SettingsSidebar>
        <PageHeading title="GDPR" />

        <OverflowFrame>
          <div className="my-5">
            <Field >
              <div  className="w-40">
                <Label>Opt-in expiration period</Label>
                <div className="my-2">
                  <SelectInput
                    options={OPTIN_EXPIRATION_PERIOD_OPTIONS}
                    value={optinExpirationPeriodInYears}
                    selected={optinExpirationPeriodInYears}
                    onChange={handleOptinExpirationPeriodChange}
                  />
                </div>
              </div>

              <Description>
                Contacts who have not interacted for longer than this period
                will be automatically opted out.
              </Description>
            </Field>

          </div>
          <Divider />
        </OverflowFrame>
      </SettingsSidebar>
    </>
  );
}
